import { auditStore } from '@/models/stores/audits.ts';
import { emojiReactionsStore } from '@/models/stores/emoji-reactions.ts';
import { fileMetadataStore } from '@/models/stores/files.ts';
import { lenderStore } from '@/models/stores/lenders.ts';
import { paymentStore } from '@/models/stores/payments.ts';
import { priceBreakdownStore } from '@/models/stores/price-breakdown.ts';
import { protectionPlanStore } from '@/models/stores/protection-plans.ts';
import { userStore } from '@/models/stores/users.ts';
import type { ArchivedDeal } from '@/models/types.ts';
import { compact } from 'lodash';

export type UpsertConfig<T> = {
  store: { upsert: (entity: any) => void };
  extractor: (deal: ArchivedDeal) => T | T[] | null | undefined;
  itemProcessor?: (item: T, deal: ArchivedDeal) => void;
};

export const UPSERT_CONFIG: UpsertConfig<any>[] = [
  {
    store: lenderStore,
    extractor: (d) => d.lender,
  },
  {
    store: userStore,
    extractor: (d) =>
      compact([d.finance_manager, d.primary_sales_rep, d.secondary_sales_rep]),
  },
  {
    store: priceBreakdownStore,
    extractor: (d) => d.price_breakdown,
  },
  {
    store: paymentStore,
    extractor: (d) => d.payments,
  },
  {
    store: fileMetadataStore,
    extractor: (d) => d.files,
  },
  {
    store: protectionPlanStore,
    extractor: (d) => d.protection_plan,
  },
  {
    store: auditStore,
    extractor: (d) => d.audits,
  },
  {
    store: emojiReactionsStore,
    extractor: (d) => d.emoji_reactions,
  },
];
